<template>
	<div class="modal fade" ref="modal">
		<div class="modal-dialog modal-lg">
			<div v-if="data != null" class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">{{ data.file }}</h4>
				</div>
				<div class="modal-body" v-html="documentData"></div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				data: null,
			};
		},
		computed: {
			documentData() {
				if (this.data == null) return '';
				let data = JSON.stringify(this.data.data);
				data = data.replace(/\\n/gi, '<br>');
				return JSON.parse(data);
			},
		},
		methods: {
			open(row) {
				this.data = row;
				setTimeout(() => $(this.$refs.modal).modal('show'), 100);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/extratos/components/mdView/index.vue